<template>

  <section class="bulk-issue-surface bulk-issue-surface--blocked">

    <div class="bulk-issue-surface__toolbar">

      <div class="bulk-issue-surface__meta">
         <strong>{{ items.length }}</strong
        > hóa đơn không đủ điều kiện xóa trong lượt này
      </div>

    </div>

     <b-table
      :items="items"
      :fields="fields"
      small
      bordered
      responsive
      show-empty
      empty-text="Không có hóa đơn bị chặn"
      class="bulk-issue-table"
      > <template #cell(saleInvoiceCode)="{ item }"
        >
        <div class="bulk-issue-table__primary-cell">
           <strong>{{ item.saleInvoiceCode || item.salesInvoiceId }}</strong
          >
        </div>
         </template
      > <template #cell(buyerName)="{ item }"
        > <span :class="{ 'bulk-issue-table__fallback': !item.buyerName }"
          > {{ item.buyerName || 'Không có thông tin' }} </span
        > </template
      > <template #cell(blockedReason)="{ item }"
        > <span class="bulk-delete-table__reason-pill"
          >{{ item.blockedReason ? item.blockedReason.label : '—' }}</span
        > </template
      > </b-table
    >
  </section>

</template>

<script>
  export default {
    name: 'BulkDeleteBlockedTable',
    props: {
      items: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      fields() {
        return [
          { key: 'saleInvoiceCode', label: 'Số HĐ nguồn' },
          { key: 'buyerName', label: 'Khách hàng' },
          { key: 'blockedReason', label: 'Lý do' },
        ]
      },
    },
  }
</script>

<style scoped>
  .bulk-issue-surface {
    border: 1px solid #e1e7ef;
    border-radius: 12px;
    background: #fff;
    overflow: hidden;
  }

  .bulk-issue-surface--blocked {
    border-color: #ebd9bf;
  }

  .bulk-issue-surface__toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.85rem 1rem 0.65rem;
    border-bottom: 1px solid #edf1f6;
    background: #fffaf1;
  }

  .bulk-issue-surface__meta {
    color: #445166;
    font-size: 0.84rem;
  }

  .bulk-issue-table {
    margin-bottom: 0;
  }

  ::v-deep .bulk-issue-table table {
    margin-bottom: 0;
  }

  ::v-deep .bulk-issue-table thead th {
    background: #f9fafb;
    color: #445166;
    font-size: 0.76rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .bulk-issue-table__primary-cell {
    display: flex;
    flex-direction: column;
    gap: 0.18rem;
  }

  .bulk-issue-table__primary-cell strong {
    color: #1f2a3d;
    font-size: 0.92rem;
    font-weight: 700;
  }

  .bulk-issue-table__fallback {
    color: #8a94a5;
    font-style: italic;
  }

  .bulk-delete-table__reason-pill {
    display: inline-flex;
    align-items: center;
    padding: 0.26rem 0.58rem;
    border-radius: 999px;
    background: #fff8e6;
    color: #a07000;
    font-size: 0.74rem;
    font-weight: 700;
    line-height: 1.2;
  }

  @media (max-width: 767.98px) {
    .bulk-issue-surface__toolbar {
      flex-direction: column;
      align-items: stretch;
    }
  }
</style>
